import { motion } from "framer-motion";

const ScienceSection = () => (
  <section className="py-24 lg:py-36 border-t border-white/10 geo-grid relative" data-testid="science-section">
    <div
      aria-hidden="true"
      className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_20%,#0A0A0A_80%)] pointer-events-none"
    />
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      >
        <p className="font-mono-tech text-xs uppercase tracking-[0.35em] text-[#00FF8F] mb-6" data-testid="science-overline">
          02 / The Neurobiological Blueprint
        </p>
        <h2 className="font-serif-display text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-tight text-white font-medium" data-testid="science-heading">
          The HPA axis and
          <span className="italic text-[#00FF8F]"> the hijacking.</span>
        </h2>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
        className="mt-12 space-y-8 text-base lg:text-lg leading-relaxed text-[#A6A6AD] font-light"
        data-testid="science-body"
      >
        <p>
          When your system detects business friction, the amygdala fires, activating the{" "}
          <strong className="font-semibold text-white">HPA (Hypothalamic-Pituitary-Adrenal) axis</strong>{" "}
          and flooding your bloodstream with chronic cortisol. This hormonal surge requisits
          oxygen and glucose away from your prefrontal cortex—your executive mind—to prepare
          skeletal muscles for fight or flight.
        </p>
        <p>
          Your brainwaves lock into{" "}
          <strong className="font-semibold text-white">high-Beta frequencies</strong>, causing
          cognitive fragmentation and strategic hypofrontality. Furthermore, chronic stress
          triggers leaky gut, shifting the tryptophan pathway via the{" "}
          <strong className="font-semibold text-white">IDO enzyme</strong> away from serotonin
          synthesis to produce neurotoxic quinolinic acid.
        </p>
        <p>
          You are biologically stripped of clarity, trapped in the{" "}
          <strong className="font-semibold text-white">Scared Child or Critical Parent</strong>{" "}
          ego states. Biology dictates the transaction.
        </p>
      </motion.div>
    </div>
  </section>
);

export default ScienceSection;
